module.exports = __webpack_public_path__ + "img/jnst.b77d9e71.png";